import SaralLogoPDFPreviewPage from '@/components/Icons/icons/SaralLogoPDFPreviewPage';

import SignButton from './SignButton';

const SigningHeader = ({ influencerSignatureMeta, setShowSignatureModal }) => (
  <div className="contract-signing-header">
    <SaralLogoPDFPreviewPage />
    <SignButton onClick={() => setShowSignatureModal(true)} influencerSignatureMeta={influencerSignatureMeta} />
  </div>
);

export default SigningHeader;
